import { Infra3DGeoserver } from "../../layer/internal";
import { AxisLoader } from "./internal";
export class AxisAGLoader extends AxisLoader {
    constructor(scene, opt_options) {
        super(scene);
        const options = opt_options || {};
        this.api =
            options.api || new Infra3DGeoserver(options.baseurl, options.project, scene.viewer, options.apioptions);
    }
    loadaxis(extent, srid, cbf) {
        const addconst = 0.1;
        const urlparams = {
            bbox: [
                extent.minx - addconst,
                extent.miny - addconst,
                extent.maxx + addconst,
                extent.maxy + addconst,
            ].join(),
            requestsrid: srid,
            // order_by: "SORT",
        };
        this.api.readfeatures("achssektoren", (geojson) => {
            AxisAGLoader.addAxisName(geojson, "name");
            const k_axissegments = AxisLoader.orderByAxisId(geojson, "name", 0.001);
            const json = {
                value: k_axissegments,
            };
            cbf(json);
        }, (message) => {
            console.log(message);
        }, urlparams);
    }
    static addAxisName(geojson, axisnameattribute = "name") {
        for (const feature of geojson.features) {
            const axisidattributearray = ["AXISNAME", "SEGMENT"];
            const axisname = [];
            for (const key of axisidattributearray) {
                axisname.push(feature.properties[key]);
            }
            feature.properties[axisnameattribute] = axisname.join(" ");
        }
    }
}
//# sourceMappingURL=ag.js.map